module.exports = __webpack_public_path__ + "img/instagram.4222eb41.svg";